import dayjs from "dayjs";
import { Expense } from "@/types/expense";
import { ColumnsType } from "antd/es/table";
import { formatCurrency } from "@/utils/currency";
import { formatQuantity } from "@/utils/numbers";
import { Button, Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { ColumnsProps } from "@/components/table";
import { DATE_FORMAT_TABLE_SHORT } from "@/constants/date";
import { ExpenseType } from "@/types/expenseType";

type GetColumnsProps = ColumnsProps<Expense> & {
  expenseType?: ExpenseType;
};

export const getColumns = ({
  expenseType,
  filterOptions,
  filterValues,
  onEdit,
  onDelete,
  getSortOrder,
}: GetColumnsProps): ColumnsType<Expense> => {
  if (!expenseType) {
    return [];
  }

  return [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: true,
      sortOrder: getSortOrder?.("date"),
      render: (date: string) => dayjs(date).format(DATE_FORMAT_TABLE_SHORT),
      hidden: !expenseType.required_fields?.includes("date"),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      align: "right",
      sorter: true,
      sortOrder: getSortOrder?.("price"),
      render: (price: number) => formatCurrency(price),
      hidden: !expenseType.required_fields?.includes("price"),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      align: "right",
      sorter: true,
      sortOrder: getSortOrder?.("quantity"),
      render: (quantity: number) =>
        quantity ? formatQuantity(quantity, 2) : "-",
      hidden: !expenseType.required_fields?.includes("quantity"),
    },
    {
      title: "Unit",
      dataIndex: ["unit", "name"],
      key: "unit_id",
      sorter: true,
      sortOrder: getSortOrder?.("unit.name"),
      filterSearch: true,
      filters: filterOptions?.unit_id,
      filteredValue: filterValues?.unit_id || null,
      render: (name: string) => name || "-",
      hidden: !expenseType.required_fields?.includes("unit"),
    },
    {
      title: "Supplier",
      dataIndex: ["supplier", "name"],
      key: "supplier_id",
      sorter: true,
      sortOrder: getSortOrder?.("supplier.name"),
      filterSearch: true,
      filters: filterOptions?.supplier_id,
      filteredValue: filterValues?.supplier_id || null,
      render: (name: string) => name || "-",
      hidden: !expenseType.required_fields?.includes("supplier"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: Expense) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
            type="link"
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => onDelete?.(record)}
            type="link"
            danger
          />
        </Space>
      ),
    },
  ];
};
